import { useState } from 'react';
import { useMediaSwapStore } from './mediaSwap-store';
import { useCanvasStore } from '../../store/canvas-store';
import { ingestImage } from '../../assets/ingestImage';

/** Picker for frame.setNodeMedia: drop / paste a file, or type a URL. */
export function MediaSwapModal() {
  const target = useMediaSwapStore((s) => s.target);
  const close = useMediaSwapStore((s) => s.close);
  const dispatch = useCanvasStore((s) => s.dispatch);
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  if (!target) return null;

  const apply = (ref: string) => {
    dispatch({ t: 'frame.setNodeMedia', frameId: target.frameId, cfNodeId: target.cfNodeId, ref });
    setUrl('');
    close();
  };

  const fromBlob = async (blob: Blob) => {
    setBusy(true);
    try {
      apply(await ingestImage(blob));
    } finally {
      setBusy(false);
    }
  };

  const onDrop = (e: React.DragEvent) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) void fromBlob(file);
  };
  const onPaste = (e: React.ClipboardEvent) => {
    const file = Array.from(e.clipboardData.files)[0];
    if (file) void fromBlob(file);
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/30" onClick={close}>
      <div
        className="w-[360px] rounded-[8px] bg-[var(--color-surface)] shadow-[var(--shadow-2)] border border-[var(--color-border)] p-4 font-sans text-[13px] flex flex-col gap-3"
        onClick={(e) => e.stopPropagation()}
        onPaste={onPaste}
      >
        <div className="text-[var(--color-text)] font-medium">Swap media</div>
        <div
          onDragOver={(e) => e.preventDefault()}
          onDrop={onDrop}
          className="rounded-[6px] border border-dashed border-[var(--color-border)] py-8 text-center text-[var(--color-text-muted)]"
        >
          {busy ? 'Storing…' : 'Drop an image/video here, or paste'}
        </div>
        <div className="flex items-center gap-2">
          <input
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="…or paste a URL"
            className="flex-1 rounded-[4px] bg-[var(--color-bg)] border border-[var(--color-border)] px-2 py-1 outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)]"
          />
          <button
            className="text-[var(--color-accent)] hover:underline disabled:opacity-50"
            disabled={!url.trim()}
            onClick={() => apply(url.trim())}
          >Use URL</button>
        </div>
        <div className="flex justify-end">
          <button className="text-[var(--color-text-muted)] hover:text-[var(--color-text)]" onClick={close}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
